import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { TableBodyStyled } from './TableBody.styled';
const TableBody = forwardRef((props, ref) => {
    return _jsx(TableBodyStyled, { ref: ref, ...props });
});
export { TableBody };
